export const BankAccountTypes = [
  { value: 1, label: 'Checking' },
  { value: 2, label: 'Saving' },
]

export const BankAccounVerificationStatusId = {
  InReview: 1,
  Accepted: 2,
  Rejected: 3,
}
